var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    rx: 2,
    fill: "#C6C6C6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 26,
    height: 4,
    rx: 2,
    fill: "#C6C6C6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 17,
    width: 26,
    height: 4,
    rx: 2,
    fill: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.660347ab5bf95f0fb9679abf89018909.svg";
export { ForwardRef as ReactComponent };